var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0234 0.976562C16.4805 1.39844 16.4805 2.13672 16.0234 2.55859L7.02344 11.5586C6.60156 12.0156 5.86328 12.0156 5.44141 11.5586L0.941406 7.05859C0.484375 6.63672 0.484375 5.89844 0.941406 5.47656C1.36328 5.01953 2.10156 5.01953 2.52344 5.47656L6.21484 9.16797L14.4414 0.976562C14.8633 0.519531 15.6016 0.519531 16.0234 0.976562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tickIcon.19e403aa991e0e340b65bf6579e554a9.svg";
export { ForwardRef as ReactComponent };